function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Button, Callout, Grid, GridItem, TextButton, Typography } from 'seagull';
import { useStore } from "../../../contexts";
import { usePaymentMethodLearnMoreModal } from "../../PaymentMethodLearnMoreModal/usePaymentMethodLearnMoreModal";
import BankSecurityRow from "../../BankSecurityRow/BankSecurityRow";
import StripeElementsProvider from "../../../providers/StripeElementsProvider";
import { selectors } from "../../../store/state-selectors";
import MinisiteTabHeader from "../MinisiteTabHeader/MinisiteTabHeader";
import styles from "./PaymentMethods.module.scss";
import ManagePaymentMethods from "../../ManagePaymentMethods/ManagePaymentMethods";
import { relationshipModel } from "../../../models";
import { useEnterAccountantAccess } from "../../../hooks/useEnterAccountantAccess";
export default function PaymentMethods(props) {
  const {
    isVendor,
    agreement,
    onRefreshAgreement
  } = props;
  const isMemberUser = useStore(selectors.user.isMemberUser);
  const isAccountant = useStore(selectors.user.isAccountant);
  const businessesWithAccountantAccess = useStore(selectors.user.businessesWithAccountantAccess);
  const isMemberClient = !isVendor && isMemberUser;
  const openLearnMoreModal = usePaymentMethodLearnMoreModal();
  const hasAccountantAccess = isVendor && businessesWithAccountantAccess.has(relationshipModel.customer(agreement));
  const onEnterAccountantAccess = useEnterAccountantAccess();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MinisiteTabHeader, {
    "data-testid": "payment-methods-page-header",
    text: /*#__PURE__*/React.createElement(React.Fragment, null, "Payment Methods", /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraph2"
    }, isVendor ? "View your client's payment methods." : 'Select a payment method to connect. You will only pay what is stated in the agreement.', ' ', /*#__PURE__*/React.createElement(TextButton, {
      onClick: openLearnMoreModal
    }, "Learn more")))
  }), /*#__PURE__*/React.createElement(Grid, null, !relationshipModel.isTerminated(agreement) && /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(StripeElementsProvider, null, /*#__PURE__*/React.createElement(ManagePaymentMethods, _extends({
    vendorId: relationshipModel.vendor(agreement),
    showCreditCardFee: !relationshipModel.isVendorCoveringCCFee(agreement),
    isProposal: false,
    isPreview: false,
    isSample: relationshipModel.isSample(agreement),
    isMemberClient: isMemberClient,
    hideInviteMemberHint: isVendor,
    isInviteMemberDisabled: isAccountant || relationshipModel.isSample(agreement),
    relationshipId: relationshipModel.id(agreement),
    onPaymentMethodUpdated: () => onRefreshAgreement({
      silent: true
    })
  }, props)))), hasAccountantAccess && /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(Callout, {
    className: styles.accountantAccessCallout
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.accountantAccessCalloutContent
  }, /*#__PURE__*/React.createElement(Typography, null, "To make changes to your client's payment methods, log in to their account using Accountant Access."), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "switch-to-accountant",
    skin: "primaryOutline",
    onClick: e => {
      e.stopPropagation(); // Prevents the row <button> element from redirecting to its target.

      onEnterAccountantAccess(relationshipModel.customer(agreement), relationshipModel.customerName(agreement));
    }
  }, "Log in as accountant")))), /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(BankSecurityRow, null))));
}